import ExportButton from '@/components/Chart/ExportButton';
import type { SymbolKey } from '@/entities/symbol/types';
import { addSymbols } from '@/features/SymbolSelector/store/symbolSelector.slice';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { getAllMiniTableSymbols } from '@/pages/Markets/MarketsComponents/MiniTablesContainer/utils/getMiniTableSymbols';
import { getSymbolsFromRows } from '@/pages/Markets/MarketsComponents/utils/getSymbolsFromRows';
import { openExportDrawer } from '@/slices/drawerSlice';
import { setExport } from '@/slices/exportSlice';
import type {
  BaseTabType,
  MarketsGraphType,
  MarketsMinitableType,
  MarketsTableType
} from '@/types/markets';

function getSymbolsFromTable(tab: MarketsTableType): SymbolKey[] {
  return tab.sections.flatMap(section => getSymbolsFromRows(section.rows));
}
const isExportSupportedTab = (
  tab: BaseTabType
): tab is MarketsTableType | MarketsMinitableType | MarketsGraphType =>
  tab.type === 'table' || tab.type === 'minitable';

const ExportWidgetButton = ({ tab }: { tab: BaseTabType }) => {
  const dispatch = useAppDispatch();

  const handleClick = () => {
    let symbols: SymbolKey[] = [];
    switch (tab.type) {
      case 'table': {
        symbols = getSymbolsFromTable(tab);
        break;
      }
      case 'minitable': {
        symbols = getAllMiniTableSymbols(tab.tables);
        break;
      }
      default:
        console.error('Unsupported export type');
    }
    dispatch(addSymbols({ symbols }));
    dispatch(openExportDrawer({ showHistory: false }));
    dispatch(setExport({}));
  };

  if (!isExportSupportedTab(tab)) {
    return null;
  }

  return (
    <ExportButton
      handleClick={handleClick}
      title='Export widget'
    />
  );
};

export default ExportWidgetButton;
